import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { LawsService } from '../../../../services/api/general-settings/laws.service';
import { LawsFormComponent } from '../components/laws-form/laws-form.component';

@Component({
  selector: 'app-laws-edit-page',
  imports: [LawsFormComponent],
  templateUrl: './laws-edit-page.component.html',
  styleUrl: './laws-edit-page.component.scss'
})
export class LawsEditPageComponent {
  lawId!: number
  law?: any;
  
  constructor(
    private route: ActivatedRoute,
    private lawsService: LawsService,
  ) {
  }

  ngOnInit(): void {
    this.lawId = Number(this.route.snapshot.paramMap.get('lawId'));
    if (this.lawId) {
      this.loadData(this.lawId);
    }
  }

  loadData(lawId: any) {
    this.lawsService.detail(lawId).subscribe((response: any) => {
      this.law = response.data?.law;
    });

  }
  onLawFormSavedData(savedDataInfo: SavedDataInfo) {
    if (savedDataInfo.success) {
      this.loadData(savedDataInfo.response?.data?.user?.userId);
    }
  }
}
